const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// Keep the page fully readable without JavaScript. Reveal styling is only
// enabled once this module has actually taken ownership of the elements.
const revealItems = [...document.querySelectorAll<HTMLElement>('[data-reveal]')];
if (!reduceMotion.matches && 'IntersectionObserver' in window) {
  revealItems.forEach((item) => item.classList.add('will-reveal'));
  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 },
  );
  revealItems.forEach((item) => observer.observe(item));
} else {
  revealItems.forEach((item) => item.classList.add('is-visible'));
}

const header = document.querySelector<HTMLElement>('[data-header]');
const setHeaderState = () => header?.classList.toggle('scrolled', window.scrollY > 18);
setHeaderState();
window.addEventListener('scroll', setHeaderState, { passive: true });

const navToggle = document.querySelector<HTMLButtonElement>('[data-nav-toggle]');
const siteLinks = document.querySelector<HTMLElement>('[data-site-links]');

function setNavigation(open: boolean): void {
  if (!navToggle || !siteLinks) return;
  navToggle.setAttribute('aria-expanded', String(open));
  navToggle.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
  siteLinks.classList.toggle('open', open);
}

navToggle?.addEventListener('click', () => {
  setNavigation(navToggle.getAttribute('aria-expanded') !== 'true');
});

siteLinks?.addEventListener('click', (event) => {
  if ((event.target as HTMLElement).closest('a')) setNavigation(false);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || navToggle?.getAttribute('aria-expanded') !== 'true') return;
  setNavigation(false);
  navToggle.focus();
});

// A small pointer response gives the hero physicality without running another
// canvas or competing with the product itself. It is disabled for touch and
// reduced-motion users.
const tiltHost = document.querySelector<HTMLElement>('[data-tilt-host]');
const tiltTarget = tiltHost?.querySelector<HTMLElement>('[data-tilt]');
if (tiltHost && tiltTarget && matchMedia('(pointer: fine)').matches && !reduceMotion.matches) {
  tiltHost.addEventListener('pointermove', (event) => {
    const bounds = tiltHost.getBoundingClientRect();
    const x = (event.clientX - bounds.left) / bounds.width - 0.5;
    const y = (event.clientY - bounds.top) / bounds.height - 0.5;
    tiltTarget.style.transform = `rotateY(${-8 + x * 3.2}deg) rotateX(${2.5 - y * 2.4}deg) translate3d(${x * 4}px, ${y * 4}px, 0)`;
  });
  tiltHost.addEventListener('pointerleave', () => {
    tiltTarget.style.removeProperty('transform');
  });
}

document.querySelector<HTMLElement>('[data-year]')!.textContent = String(new Date().getFullYear());
